import React, { useState, useEffect } from 'react'
import List from './Components/List'
import Create from './Components/Create'
import { store } from '../../app/store';
import { postAPI } from '../../app/api';

export default function Referrals() {
    const store_data = JSON.parse(store());
    const [is_edit, setIsEdit] = useState(false);
    const [edit_id, setEditId] = useState(0);
    const [current_reward_amount, setCurrentRewardAmount] = useState(0);
    useEffect(() => {
        fetchCurrentRewardAmount();
    }, []);
    const fetchCurrentRewardAmount = async () => {
        const response = await postAPI('/referral/fetch-current-reward-amount', { org_id: store_data?.org_id });
        if (response?.status === 1) {
            setCurrentRewardAmount(response?.data?.referral_reward_amount || 0);
        }
    }
    const handleReferralRewardUpdate = async (e) => {
        e.preventDefault();
        const form = document.getElementById("ReferralRewardForm");
        const formData = new FormData(form);
        console.log("Form Data: ", Object.fromEntries(formData.entries()));
        const response = await postAPI('/referral/update-reward-amount', {referral_reward_amount: formData.get('referral_reward_amount'), org_id: store_data?.org_id});
        fetchCurrentRewardAmount();
    }
    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Dashboard'; }}>
                                Back
                            </button>
                            <p className='text-right mb-0'><small className="fw-bold py-3">Dashboard<span className="text-muted fw-light"> / Referrals</span> </small></p>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className='card-title mb-0'>Referrals</h5>
                                <div className='col-md-4'>
                                    <form onSubmit={handleReferralRewardUpdate} id="ReferralRewardForm" className='row'>
                                        <div className='col-md-6'>
                                            <input type="number" name="referral_reward_amount" value={current_reward_amount || 0} className='form-control' placeholder='Referral Reward' onChange={(e) => setCurrentRewardAmount(e.target.value)} />
                                        </div>
                                        <div className='col-md-6'>
                                            <button type="submit" className='btn btn-primary'>Update</button>
                                        </div>
                                    </form>
                                </div>
                                {/* <Create BTNLabel={"Add Referral"} Header={is_edit ? "Update Referral" : "Create Referral"} Subheader="" PopupID="Referrals" is_edit={is_edit} setIsEdit={setIsEdit} edit_id={edit_id} setEditId={setEditId} /> */}
                            </div>
                            <div className="card-datatable table-responsive">
                                <List PopupID="Referrals" setIsEdit={setIsEdit} setEditId={setEditId} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
